(adsbygoogle = window.adsbygoogle || []).pauseAdRequests = 1;

(function () {
    // Run this in an interval (every 0.1s) just in case we are still waiting for consent
    var cnt = 0;
    var consentSetInterval = setInterval(function () {
        cnt += 1;

        // Bail if we have not gotten a consent response after 60 seconds.
        if (cnt === 600) {
            clearInterval(consentSetInterval);
        }

        if (typeof window.__tcfapi !== 'undefined') { // Check if window.__tcfapi has been set
            clearInterval(consentSetInterval);

            window.__tcfapi('addEventListener', 2, function (tcData, listenerSuccess) {
                if (listenerSuccess) {
                    if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {
                        if (!tcData.gdprApplies) {

                            // GDPR DOES NOT APPLY, UnpauseAdRequests

                            // Set request non-personalized ads to false as GDPR does not apply.
                            (adsbygoogle = window.adsbygoogle || []).requestNonPersonalizedAds = 0;

                            // Unpause ads, as GDPR does not apply.
                            (adsbygoogle = window.adsbygoogle || []).pauseAdRequests = 0;
                        }
                        else {

                            // GDPR DOES APPLY

                            // Purpose 1 refers to the storage and/or access of information on a device.
                            var hasDeviceStorageAndAccessConsent = tcData.purpose.consents[1] || false;

                            // Google Requires Consent for Purpose 1
                            if (hasDeviceStorageAndAccessConsent) {
                                // GLOBAL VENDOR LIST - https://iabeurope.eu/vendor-list-tcf-v2-0/
                                // CHECK FOR GOOGLE ADVERTISING PRODUCTS CONSENT. (IAB Vendor ID 755)
                                var hasGoogleAdvertisingProductsConsent = tcData.vendor.consents[755] || false;

                                // Check if the user gave Google Advertising Products consent (iab vendor 755)
                                if (hasGoogleAdvertisingProductsConsent) {
                                    var hasPersonalizedProfileConsent = tcData.purpose.consents[3] || false;
                                    var hasPersonalizedAdsConsent = tcData.purpose.consents[4] || false;

                                    // Check if have add personalization consent Purpose 3 and 4
                                    if (hasPersonalizedAdsConsent && hasPersonalizedProfileConsent) {
                                        // Set request non-personalized ads to false.
                                        (adsbygoogle = window.adsbygoogle || []).requestNonPersonalizedAds = 0;
                                    }
                                    else {
                                        // Set request non-personalized ads to true.
                                        (adsbygoogle = window.adsbygoogle || []).requestNonPersonalizedAds = 1;
                                    }

                                    // Unpause ads , the user has granted consent for purpose 1 and given google consent.
                                    (adsbygoogle = window.adsbygoogle || []).pauseAdRequests = 0;
                                }
                            }
                        }
                    }
                }
            });
        }
        cnt++;
    }, 100);
})();
